
import { Injectable } from '@angular/core';
import { LookupDataService } from '../../http/lookupdata.service';
import { CommonUtilty } from '../../utilities/commonUtility'
import { FormBuilder, FormGroup, Validators, FormControl, AbstractControl } from '@angular/forms';
import { CustomValidators } from 'ngx-custom-validators';
import { Observable, forkJoin } from 'rxjs';
import * as moment from 'moment/moment'
import { NzMessageService } from 'ng-zorro-antd/message';

export interface ValidationItem {
  fieldKey: string;
  controlId: string;
  validation: string;
  errorMessage: string;
  valueForParameter?: any;
  additionalParameter?: any;
  severity?: string;
  state?: any
}

export interface ValidationPacket {
  validation: string;
  valueForParameter?: string;
}

@Injectable()
export class ValidationUtilService {

  /** 
   * Author: Ninad Kulkarni
   * 
   * Supported Native Angular Validations
   * min(), max(), required(), requiredTrue(), email(), 
   * minLength(), maxLength(), pattern()
   * 
   * Supported Custom Validations
   * array length, base64, credit card, date, date ISO, 
   * digits, email, equal, not equal, equal to, not equal to, 
   * greater than, greater than or equal, json, less than, 
   * less than or equal, max, max date, min, min date, not equal, 
   * not equal to, number, property, range, range length, url, uuid
  */

  constructor(private commonUtilty: CommonUtilty, private msg: NzMessageService) { }

  newStructure = {
    validationEvent: null,
    state: null,
    fieldKey: 'firstName',
    controlId: 'agentRegistration',
    validation: 'maxlength',
    valueForParameter: null,
    additionalParameter: null,
    severity: null,
    errorMessage: 'First Name is required'
  }

  validationList = [
    "required",
    "requiredTrue",
    "email",
    "min",
    "max",
    "minlength",
    "maxlength",
    "pattern",
    "digits",
    "number",
    "url",
    "date",
    "dateISO",
    "creditCard",
    "json",
    "base64",
    "minDate",
    "maxDate",
    "uuid",
    "equal",
    "notEqual",
    "equalTo",
    "notEqualTo",
    "arrayLength",
    "greaterThan",
    "lessThan",
    "range",
    "rangeLength"
  ]


  dummyValidations = [
    // { validationLevel: null, state: null, fieldName: 'firstName', formName: 'agentRegistration', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'First Name is required' },
    // { validationLevel: null, state: null, fieldName: 'firstName', formName: 'agentRegistration', validation: 'maxlength', valueForParameter: '50', additionalParameter: 'null', type: 'null', errorMessage: 'First Name cannot be more than 50 characters' },
    // { validationLevel: null, state: null, fieldName: 'userRoleCd', formName: 'agentRegistration', validation: 'null', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'null' },
    // { validationLevel: null, state: null, fieldName: 'userStatusCd', formName: 'agentRegistration', validation: 'null', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'null' },
    // { validationLevel: null, state: null, fieldName: 'contactPerson', formName: 'agentRegistration', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Contact Person is Required' },
    // { validationLevel: null, state: null, fieldName: 'agentDesignationCd', formName: 'agentRegistration', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Agent designation is required' },
    // { validationLevel: null, state: null, fieldName: 'countryCd', formName: 'agentRegistration', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Country is required' },
    // { validationLevel: null, state: null, fieldName: 'cityCd', formName: 'agentRegistration', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'City is required' },
    // { validationLevel: null, state: null, fieldName: 'divisionCd', formName: 'agentRegistration', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Division is required' },
    // { validationLevel: null, state: null, fieldName: 'subDivisionCd', formName: 'agentRegistration', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Subdivision is required' },
    // { validationLevel: null, state: null, fieldName: 'partnerName', formName: 'agentRegistration', validation: 'null', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'null' },
    // { validationLevel: null, state: null, fieldName: 'clientTypeCd', formName: 'agentRegistration', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Client Type is required' },
    // { validationLevel: null, state: null, fieldName: 'licenseIssueDt', formName: 'agentRegistration', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'License Issue Date is required' },
    // { validationLevel: null, state: null, fieldName: 'licenseExpiryDt', formName: 'agentRegistration', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'License Expiry Date is required' },
    // { validationLevel: null, state: null, fieldName: 'licenseNum', formName: 'agentRegistration', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'License Number  is required' },
    // { validationLevel: null, state: null, fieldName: 'categoryCd', formName: 'agentRegistration', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Agent Category is required' },
    // { validationLevel: null, state: null, fieldName: 'channelCd', formName: 'agentRegistration', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Channel is required' },
    // { validationLevel: null, state: null, fieldName: 'subChannelCd', formName: 'agentRegistration', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Sub-Channel is required' },
    // { validationLevel: null, state: null, fieldName: 'emailId', formName: 'agentRegistration', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Email is required' },
    // { validationLevel: null, state: null, fieldName: 'emailId', formName: 'agentRegistration', validation: 'email', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Email is invalid' },
    // { validationLevel: null, state: null, fieldName: 'statusCd', formName: 'agentRegistration', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Status is required' },
    // { validationLevel: null, state: null, fieldName: 'mobileNum', formName: 'agentRegistration', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Mobile is required' },
    // { validationLevel: null, state: null, fieldName: 'mobileNum', formName: 'agentRegistration', validation: 'minlength', valueForParameter: '8', additionalParameter: 'null', type: 'null', errorMessage: 'Mobile Number should atleast be 8 digits' },
    // { validationLevel: null, state: null, fieldName: 'mobileNum', formName: 'agentRegistration', validation: 'maxlength', valueForParameter: '18', additionalParameter: 'null', type: 'null', errorMessage: 'Mobile Number cannot be more than 18 digits' },
    // { validationLevel: null, state: null, fieldName: 'workNum', formName: 'agentRegistration', validation: 'null', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'null' },
    // { validationLevel: null, state: null, fieldName: 'addressLine1', formName: 'agentRegistration', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Address Line 1 is required' },
    // { validationLevel: null, state: null, fieldName: 'addressLine1', formName: 'agentRegistration', validation: 'maxlength', valueForParameter: '200', additionalParameter: 'null', type: 'null', errorMessage: 'Address Line 1 cannot be more than 200 characters' },
    // { validationLevel: null, state: null, fieldName: 'addressLine2', formName: 'agentRegistration', validation: 'null', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'null' },
    // { validationLevel: null, state: null, fieldName: 'postCode', formName: 'agentRegistration', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Postal Code is required' },
    // { validationLevel: null, state: null, fieldName: 'postCode', formName: 'agentRegistration', validation: 'maxlength', valueForParameter: '5', additionalParameter: 'null', type: 'null', errorMessage: 'Postal Code cannot be more than 5 characters' },
    // { validationLevel: null, state: null, fieldName: 'stateCd', formName: 'agentRegistration', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Province is required' },
    // { validationLevel: null, state: null, fieldName: 'vatApplicableFl', formName: 'agentRegistration', validation: 'null', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'null' },
    // { validationLevel: null, state: null, fieldName: 'aegisId', formName: 'agentRegistration', validation: 'null', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'null' },
    // { validationLevel: null, state: null, fieldName: 'cgissId', formName: 'agentRegistration', validation: 'null', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'null' },
    // { validationLevel: null, state: null, fieldName: 'integralId', formName: 'agentRegistration', validation: 'null', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'null' },
    // { validationLevel: null, state: null, fieldName: 'roles', formName: 'agentRegistration', validation: 'null', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'null' },
    // { validationLevel: null, state: null, fieldName: 'agentType', formName: 'agentRegistration', validation: 'null', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Agent Type is required' },
    // { validationLevel: null, state: null, fieldName: 'lastName', formName: 'agentRegistration', validation: 'null', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'null' },
    // { validationLevel: null, state: null, fieldName: 'companyCd', formName: 'agentRegistration', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Company is required' },
    // { validationLevel: null, state: null, fieldName: 'companyContactUserId', formName: 'agentRegistration', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Contact Person is Required' },
    // { validationLevel: null, state: null, fieldName: 'companyBranchCd', formName: 'agentRegistration', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Branch is required' },
    // { validationLevel: null, state: null, fieldName: 'companyName', formName: 'agentRegistration', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Company is required' },
    // { validationLevel: null, state: null, fieldName: 'branchName', formName: 'agentRegistration', validation: 'null', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'null' },
    // { validationLevel: null, state: null, fieldName: 'employeeID', formName: 'agentRegistration', validation: 'null', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'null' },
    // { validationLevel: null, state: null, fieldName: 'managerUserId', formName: 'agentRegistration', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Reporting is required' },
    // { validationLevel: null, state: null, fieldName: 'commissionAndMaxAcqValue', formName: 'agentRegistration', validation: 'null', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'null' },
    // { validationLevel: null, state: null, fieldName: 'userId', formName: 'agentRegistration', validation: 'null', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'null' },
    // { validationLevel: null, state: null, fieldName: 'agentid', formName: 'agentRegistration', validation: 'null', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'null' },
    // { validationLevel: null, state: null, fieldName: 'agentGuid', formName: 'agentRegistration', validation: 'null', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'null' },
    // { validationLevel: null, state: null, fieldName: 'clientid', formName: 'agentRegistration', validation: 'null', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'null' },
    // { validationLevel: null, state: null, fieldName: 'clientGuid', formName: 'agentRegistration', validation: 'null', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'null' },
    // { validationLevel: null, state: null, fieldName: 'personOrgId', formName: 'agentRegistration', validation: 'null', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'null' },
    // { validationLevel: null, state: null, fieldName: 'personOrgGuid', formName: 'agentRegistration', validation: 'null', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'null' },
    // { validationLevel: null, state: null, fieldName: 'agentid', formName: 'agentRegistration', validation: 'null', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'null' },
    // { validationLevel: null, state: null, fieldName: 'firstName', formName: 'clientSearchCriteriaForm', validation: 'null', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'null' },
    // { validationLevel: null, state: null, fieldName: 'lastName', formName: 'clientSearchCriteriaForm', validation: 'null', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'null' },
    // { validationLevel: null, state: null, fieldName: 'policyNum', formName: 'clientSearchCriteriaForm', validation: 'null', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'null' },
    // { validationLevel: null, state: null, fieldName: 'dateOfBirth', formName: 'clientSearchCriteriaForm', validation: 'date', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Date of Birth is Invalid' },
    // { validationLevel: null, state: null, fieldName: 'policyCommencementDt', formName: 'policySearchCriteriaForm', validation: 'null', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Date of Birth is Invalid' },
    // { validationLevel: null, state: null, fieldName: 'lastName', formName: 'policySearchCriteriaForm', validation: 'null', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'null' },
    // { validationLevel: null, state: null, fieldName: 'policyNum', formName: 'policySearchCriteriaForm', validation: 'null', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'null' },
    // { validationLevel: null, state: null, fieldName: 'dateOfBirth', formName: 'policySearchCriteriaForm', validation: 'date', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'null' },
    // { validationLevel: null, state: null, fieldName: 'eventType', formName: 'claimsBasicDetailsForm', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Event Type is required' },

    // { validationLevel: null, state: null, fieldName: 'informantRelationship', formName: 'claimsBasicDetailsForm', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Relationship is required' },
    // { validationLevel: null, state: null, fieldName: 'eventDate', formName: 'claimsBasicDetailsForm', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Event Date is required' },
    // { validationLevel: null, state: null, fieldName: 'eventDate', formName: 'claimsBasicDetailsForm', validation: 'date', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Event Date is not valid' },
    // { validationLevel: null, state: null, fieldName: 'eventDate', formName: 'claimsBasicDetailsForm', validation: 'maxDate', valueForParameter: 'tomorrow', additionalParameter: 'null', type: 'null', errorMessage: 'Event Date cannot be Future Date' },
    // { validationLevel: null, state: null, fieldName: 'placeOfDeathCd', formName: 'claimsBasicDetailsForm', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Place of death is required' },
    // //{ validationLevel: null, state: null, fieldName: 'eventTime', formName: 'claimsBasicDetailsForm', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Event Time is required' },
    // { validationLevel: null, state: null, fieldName: 'informantRoleCd', formName: 'claimsBasicDetailsForm', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Source of intimation is required' },
    // { validationLevel: null, state: null, fieldName: 'causeOfDeath', formName: 'claimsBasicDetailsForm', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Cause of death is required' },
    // { validationLevel: null, state: null, fieldName: 'claimProcessTypeCd', formName: 'claimsBasicDetailsForm', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Claim process type is required' },
    
    // { validationLevel: null, state: null, fieldName: 'claimBenefitCd', formName: 'claimsBasicDetailsForm', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Caim benefit option is required' },
    // { validationLevel: null, state: null, fieldName: 'claimConditionCd', formName: 'claimsBasicDetailsForm', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Claim condition is required' },
    // { validationLevel: null, state: null, fieldName: 'claimZoneCd', formName: 'claimsBasicDetailsForm', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Claim secondary status is required' },
    // { validationLevel: null, state: null, fieldName: 'payoutOptionCd', formName: 'claimsBasicDetailsForm', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Payout option is required'},

    // { validationLevel: null, state: null, fieldName: 'regulatedEntityCd', formName: 'claimsBasicDetailsForm', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Regulated Entity is required'},
    // { validationLevel: null, state: null, fieldName: 'auditorCertCd', formName: 'claimsBasicDetailsForm', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Auditor Certificate is required'},
    // { validationLevel: null, state: null, fieldName: 'exceptionMatrixCd', formName: 'claimsBasicDetailsForm', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Exception Matrix is required'},

    // { validationLevel: null, state: null, fieldName: 'accountNumber', formName: 'claimsBankDetailsForm', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Bank account number is required' },
    // { validationLevel: null, state: null, fieldName: 'accountHolderName', formName: 'claimsBankDetailsForm', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Account holder name is required' },
    // { validationLevel: null, state: null, fieldName: 'paymentMethodCd', formName: 'claimsBankDetailsForm', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Payment method is required' },
    // { validationLevel: null, state: null, fieldName: 'branchIdNum1', formName: 'claimsBankDetailsForm', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'IFSC is required' },
    // { validationLevel: null, state: null, fieldName: 'branchIdNum2', formName: 'claimsBankDetailsForm', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'MICR code is required' },
    // { validationLevel: null, state: null, fieldName: 'bankName', formName: 'claimsBankDetailsForm', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Bank name is required' },
    // { validationLevel: null, state: null, fieldName: 'branchName', formName: 'claimsBankDetailsForm', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Branch is required' },
    // { validationLevel: null, state: null, fieldName: 'checkNo', formName: 'claimsBankDetailsForm', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Cheque no is required' },
    // //{ validationLevel: null, state: null, fieldName: 'address', formName: 'claimsBankDetailsForm', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Address is required' },
    // //paymentRequestTypeCd,bankCd{ validationLevel: null, state: null, fieldName: 'cityCd', formName: 'claimsBankDetailsForm', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: '', errorMessage: 'City is required' },

    // { validationLevel: null, state: null, fieldName: 'paymentRequestTypeCd', formName: 'claimsBankDetailsForm', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Payment request type is required' },
    // { validationLevel: null, state: null, fieldName: 'bankCd', formName: 'claimsBankDetailsForm', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Bank code is required' },

    // { validationLevel: null, state: null, fieldName: 'title', formName: 'captureClientDetailsForm', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Title is required' },
    // { validationLevel: null, state: null, fieldName: 'clientTypeCd', formName: 'captureClientDetailsForm', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Client Type is required' },
    // { validationLevel: null, state: null, fieldName: 'gender', formName: 'captureClientDetailsForm', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Gender is required' },
    // { validationLevel: null, state: null, fieldName: 'firstName', formName: 'captureClientDetailsForm', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'First Name is required' },
    // { validationLevel: null, state: null, fieldName: 'firstName', formName: 'captureClientDetailsForm', validation: 'maxlength', valueForParameter: '50', additionalParameter: 'null', type: 'null', errorMessage: 'First Name cannot be more than 50 characters' },
    // { validationLevel: null, state: null, fieldName: 'maritalStatusCd', formName: 'captureClientDetailsForm', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'MaritalStatus is required' },
    // { validationLevel: null, state: null, fieldName: 'countryOfBirthCd', formName: 'captureClientDetailsForm', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'country of birth is required' },
    // { validationLevel: null, state: null, fieldName: 'nationality', formName: 'captureClientDetailsForm', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Nationality is required' },
    // { validationLevel: null, state: null, fieldName: 'dateOfBirth', formName: 'captureClientDetailsForm', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Date of birth is required' },
    // //{ validationLevel: null, state: null, fieldName: 'occupationCd', formName: 'captureClientDetailsForm', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Occupation is required' },
    // //{ validationLevel: null, state: null, fieldName: 'SOE', formName: 'captureClientDetailsForm', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Source of evidence is required' },






    // // { validationLevel: null, state: null, fieldName: 'middleName', formName: 'captureClientDetailsForm', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Middle Name is required' },
    // //{ validationLevel: null, state: null, fieldName: 'middleName', formName: 'captureClientDetailsForm', validation: 'maxlength', valueForParameter: '50', additionalParameter: 'null', type: 'null', errorMessage: 'Middle Name cannot be more than 50 characters' },
    // { validationLevel: null, state: null, fieldName: 'lastName', formName: 'captureClientDetailsForm', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Last Name is required' },
    // { validationLevel: null, state: null, fieldName: 'lastName', formName: 'captureClientDetailsForm', validation: 'maxlength', valueForParameter: '50', additionalParameter: 'null', type: 'null', errorMessage: 'Last Name cannot be more than 50 characters' },
    // { validationLevel: null, state: null, fieldName: 'dataOfBirth', formName: 'captureClientDetailsForm', validation: 'date', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Date of Birth is not valid' },
    // { validationLevel: null, state: null, fieldName: 'addressLine1', formName: 'uiAddressIndForm', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Address Line 1 is required' },
    // { validationLevel: null, state: null, fieldName: 'addressLine1', formName: 'uiAddressIndForm', validation: 'maxlength', valueForParameter: '200', additionalParameter: 'null', type: 'null', errorMessage: 'Address Line 1 cannot be more than 200 characters' },
    // { validationLevel: null, state: null, fieldName: 'addressLine2', formName: 'uiAddressIndForm', validation: 'null', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'null' },
    // { validationLevel: null, state: null, fieldName: 'postCode', formName: 'uiAddressIndForm', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Postal Code is required' },
    // { validationLevel: null, state: null, fieldName: 'postCode', formName: 'uiAddressIndForm', validation: 'maxlength', valueForParameter: '6', additionalParameter: 'null', type: 'null', errorMessage: 'Postal Code cannot be more than 6 characters' },
    // { validationLevel: null, state: null, fieldName: 'postCode', formName: 'uiAddressIndForm', validation: 'number', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Only numeric characters allowed' },
    // { validationLevel: null, state: null, fieldName: 'stateCd', formName: 'uiAddressIndForm', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Province is required' },
    // { validationLevel: null, state: null, fieldName: 'countryCd', formName: 'uiAddressIndForm', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Province is required' },
    // { validationLevel: null, state: null, fieldName: 'cityCd', formName: 'uiAddressIndForm', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Province is required' },
    

    // { validationLevel: 'submit', state: null, fieldName: 'manualAdjSubDecisionCd', formName: 'claimsDecisionForm', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Claim decision is required' },
    // { validationLevel: 'submit', state: null, fieldName: 'adjRemarks', formName: 'claimsDecisionForm', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Assessor Level 1 Recommendation is required' },
    // { validationLevel: 'submit', state: null, fieldName: 'adj2Remarks', formName: 'claimsDecisionForm', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Assessor Level 2 Recommendation is required' },
 
    // { validationLevel: null, state: null, fieldName: 'claimant', formName: 'claimsCaptureNominee', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Atleast one Claimant should be added.' },

    // { validationLevel: null, state: null, fieldName: 'contactNum', formName: 'claimsCaptureNominee', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Mobile number is required.' },
    // { validationLevel: null, state: null, fieldName: 'contactNum', formName: 'claimsCaptureNominee', validation: 'minlength', valueForParameter: '10', additionalParameter: 'null', type: 'null', errorMessage: 'Mobile number should be 10 digits' },


    // { validationLevel: null, state: null, fieldName: 'intimationTime', formName: 'claimsBasicDetailsForm', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Intimation time is required' },
    // { validationLevel: null, state: null, fieldName: 'intimationDt', formName: 'claimsBasicDetailsForm', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Intimation date is required' },
    // { validationLevel: null, state: null, fieldName: 'ciLevelCd', formName: 'claimsBasicDetailsForm', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Illness Level is required' },
    // { validationLevel: null, state: null, fieldName: 'illnessCd', formName: 'claimsBasicDetailsForm', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Illness is required' },



    // // for hospitalization 
    // { validationLevel: null, state: null, fieldName: 'searchHospitalName', formName: 'SearchAddHospitalListForm', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Hospital Name is required' },
    // { validationLevel: null, state: null, fieldName: 'searchDoctorName', formName: 'SearchAddDoctorListForm', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Doctor Name is required' },

    // { validationLevel: null, state: null, fieldName: 'intimationDt', formName: 'claimsBasicDetailsForm', validation: 'date', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Intimation Date is not valid' },
    // { validationLevel: null, state: null, fieldName: 'intimationDt', formName: 'claimsBasicDetailsForm', validation: 'maxDate', valueForParameter: 'tomorrow', additionalParameter: 'null', type: 'null', errorMessage: 'Intimation Date cannot be Future Date' },



    // { fieldName: 'type', formName: 'uiMultirowBasicForm', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Email Type is required' },

    //   { fieldName: 'emailId', formName: 'uiMultirowBasicForm', validation: 'required', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Email is required' },
    //   { fieldName: 'emailId', formName: 'uiMultirowBasicForm', validation: 'email', valueForParameter: 'null', additionalParameter: 'null', type: 'null', errorMessage: 'Email is invalid' },
  ]

  allValidations: Array<ValidationItem> = [
    ...this.dummyValidations
  ]

  //Integration Method
  setValidationsForFormControl(fieldKey, controlId, value?, state?, listOfValidationPackets?: Array<any>) {
    let _filteredValidationItems
    if (!this.commonUtilty.isArrayIterable(listOfValidationPackets)) {
      if (state) {
        _filteredValidationItems = this.allValidations.filter(validation => validation.fieldKey === fieldKey && validation.controlId === controlId && validation.state === state)
      }
      else {
        _filteredValidationItems = this.allValidations.filter(validation => validation.fieldKey === fieldKey && validation.controlId === controlId)
      }
    }
    else {
      listOfValidationPackets = listOfValidationPackets.map(item => {
        item['fieldKey'] = fieldKey
        item['controlId'] = controlId
        return item
      })
      _filteredValidationItems = [...listOfValidationPackets]
    }

    let _listOfValidatorsForFormControl = []
    this.allValidations = [...this.allValidations, ..._filteredValidationItems]

    _filteredValidationItems.forEach(item => {
      let fetchMetaData = this._fetchValidatorObject(item.validation, item.valueForParameter, item.additionalParameter, fieldKey, controlId)
      if (fetchMetaData != null && fetchMetaData != undefined)
        _listOfValidatorsForFormControl.push(fetchMetaData)
    })

    if (value !== null && value != undefined)
      return new FormControl(value, _listOfValidatorsForFormControl);
    else if (_listOfValidatorsForFormControl != null && _listOfValidatorsForFormControl != undefined)
      return new FormControl(null, _listOfValidatorsForFormControl);
  }

  //Integration Method
  getListOfValidators(state: any, fieldKey: any, controlId: any) {
    let _filteredValidationItems;
    if (state) {
      _filteredValidationItems = this.allValidations.filter(validation => validation.fieldKey === fieldKey && validation.controlId === controlId && validation.state === state);
    }
    else {
      _filteredValidationItems = this.allValidations.filter(validation => validation.fieldKey === fieldKey && validation.controlId === controlId);
    }
    let _listOfValidatorsForFormControl = [];
    _filteredValidationItems.forEach(item => {
      let fetchMetaData = this._fetchValidatorObject(item.validation, item.valueForParameter, fieldKey, controlId);
      if (fetchMetaData != null && fetchMetaData != undefined)
        _listOfValidatorsForFormControl.push(fetchMetaData);
    });
    return _listOfValidatorsForFormControl;
  }

  /*addListOfValidationPackets(listOfValidationPackets: any[]) {
    if (this.commonUtilty.isArrayIterable(listOfValidationPackets)) {
      let conflictingValidations = [];
      listOfValidationPackets.forEach(fieldValidation => {
        let doesThisValidationExists = this.allValidations.some(existingValidation => existingValidation.fieldKey == fieldValidation.fieldKey &&
          existingValidation.controlId == fieldValidation.controlId &&
          existingValidation.state == fieldValidation.state &&
          existingValidation.severity == fieldValidation.severity &&
          existingValidation.validation !== fieldValidation.validation
        );
        if (!doesThisValidationExists) {
          this.allValidations.push(fieldValidation);
        }
        else {
          conflictingValidations.push(fieldValidation);
        }
      });
      if (this.commonUtilty.isArrayIterable(conflictingValidations)) {
        this.msg.warning(`Configuration Warning - Conflicting client validation configuration received for ${conflictingValidations.find(c => c).controlId}`);
        console.error('Conflicting Validations -', conflictingValidations);
        console.log('All Validations - ', this.allValidations);
      }
    }
  }*/

  //Integration Method
  isRequired(fieldKey, controlId?, state?) {
    let _filteredValidationItem
    if (state) {
      _filteredValidationItem = this.allValidations.filter(validation => validation.fieldKey === fieldKey && validation.controlId === controlId && validation.validation === "required" && validation.state === state)
    }
    else {
      _filteredValidationItem = this.allValidations.filter(validation => validation.fieldKey === fieldKey && validation.controlId === controlId && validation.validation === "required")
    }

    if (_filteredValidationItem.length > 0) {
      return true
    }
    else {
      return false
    }
  }
 
  //Integration Method
  getErrorMsg(fieldKey, controlId, state?) {
    let _filteredValidationItem
    if (state) {
      _filteredValidationItem = this.allValidations.find(validation => validation.fieldKey === fieldKey && validation.controlId === controlId && validation.validation === "required" && validation.state === state)
    }
    else {
      _filteredValidationItem = this.allValidations.find(validation => validation.fieldKey === fieldKey && validation.controlId === controlId && validation.validation === "required")
    }

    // Ninad: There is a possibility that _filteredValidationItem will never find any validation.
    if (_filteredValidationItem) {
      return _filteredValidationItem.errorMessage
    }
  }

  //Integration Method
  getUIErrorList(fieldFormControl, controlId, state?) {
    var controlName = this.commonUtilty.getControlName(fieldFormControl)
    let errorlist = this._getErrorMessageList(fieldFormControl.errors, controlName, controlId, state)
    return errorlist
  }

  private _fetchValidationMetadata(listOfViewModules: Array<any>) {
    listOfViewModules.forEach(viewModule => {
      //call API for a View Module
      let respDataForAViewModule = []
      if(this.commonUtilty.isArrayIterable(respDataForAViewModule)) {
      respDataForAViewModule.forEach(respData => {
        let _validationItem: ValidationItem = {
          fieldKey: respData.fieldKey || null,
          validation: respData.validation || null,
          valueForParameter: respData.value || null,
          controlId: respData.controlId || null,
          severity: respData.severity || null,
          additionalParameter: respData.additionalParameter || null,
          errorMessage: respData.errorMessage || null
        }
        this._pushValidationItem(_validationItem);
      })
    }
    })
  }

  private _pushValidationItem(validationItem: ValidationItem) {
    this.allValidations.forEach((masterValidationItem, index) => {
      if (masterValidationItem.fieldKey === validationItem.fieldKey &&
        masterValidationItem.validation === validationItem.validation &&
        masterValidationItem.severity === validationItem.severity &&
        masterValidationItem.controlId === validationItem.controlId
      ) {
        masterValidationItem = validationItem;
      }
      else {
        this.allValidations.push(validationItem);
      }

    })
  }

  updateValidatorsForExistingControl(fieldKey, controlId, value?, state?, listOfValidationPackets?: Array<any>) {
    listOfValidationPackets = listOfValidationPackets.map(item => {
      item['fieldKey'] = fieldKey
      item['controlId'] = controlId
      return item
    })
    this.allValidations = [...this.allValidations, ...listOfValidationPackets]
    let fetchMetaDataList = [];
    if (this.commonUtilty.isArrayIterable(listOfValidationPackets)) {
      listOfValidationPackets.forEach(item => {
        let fetchMetaData = this._fetchValidatorObject(item.validation, item.valueForParameter, item.additionalParameter, fieldKey, controlId)
        if (fetchMetaData != null && fetchMetaData != undefined)
        fetchMetaDataList.push(fetchMetaData);
      })
    }
    return fetchMetaDataList;
  }
  
  private _fetchValidatorObject(validationName, value?, secondaryValue?, fieldKey?, controlId?) {

    let _noValueForValidationFoundMessage = "Invalid MetaData Values for validation received from server. " + "Field Name: " + fieldKey + "Form Name: " + controlId + "Validation: " + validationName

    /**
     * Native 
     * Validations
     * List
     */

    if (validationName === 'required')
      return Validators.required

    if (validationName === 'requiredTrue')
      return Validators.requiredTrue

    if (validationName === 'email')
      return Validators.email

    if (validationName === 'min' && value)
      return Validators.min(value)


    if (validationName === 'max' && value)
      return Validators.max(value)


    if (validationName === 'minlength' && value)
      return Validators.minLength(value)


    if (validationName === 'maxlength' && value)
      return Validators.maxLength(value)


    if (validationName === 'pattern' && value)
      return Validators.pattern(value)



    /**
      * Custom 
      * Validation
      * List
      */

    if (validationName === 'digits')
      return CustomValidators.digits

    if (validationName === 'number')
      return CustomValidators.number

    if (validationName === 'url')
      return CustomValidators.url

    if (validationName === 'date')
      return CustomValidators.date

    if (validationName === 'dateISO')
      return CustomValidators.dateISO

    if (validationName === 'creditCard')
      return CustomValidators.creditCard

    if (validationName === 'json')
      return CustomValidators.json

    if (validationName === 'base64')
      return CustomValidators.base64

    if (validationName === 'minDate' && value) {
      if (value === 'today') {
        return CustomValidators.minDate(new Date())
      }
      else if (value === 'tomorrow') {
        var today = new Date();
        var tomorrow = new Date();
        tomorrow.setDate(today.getDate() + 1);
        return CustomValidators.maxDate(tomorrow)
      }
      else if (value === 'yesterday') {
        var today = new Date();
        var yesterday = new Date();
        yesterday.setDate(today.getDate() - 1);
        return CustomValidators.minDate(yesterday)
      } else if (value === 'customToday') {
        return CustomValidators.minDate(new Date().setHours(0, 0, 0, 0))
      }
      else {
        return CustomValidators.minDate(value)
      }
    }


    if (validationName === 'maxDate' && value) {
      if (value === 'today') {
        return CustomValidators.maxDate(new Date())
      }
      else if (value === 'tomorrow') {
        var today = new Date();
        var tomorrow = new Date();
        tomorrow.setDate(today.getDate() + 1);
        return CustomValidators.maxDate(tomorrow)
      }
      else {
        return CustomValidators.maxDate(value)
      }
    }


    if (validationName === 'uuid' && value)
      return CustomValidators.uuid(value)


    if (validationName === 'equal' && value)
      return CustomValidators.equal(value)


    if (validationName === 'notEqual' && value)
      return CustomValidators.notEqual(value)

    if (validationName === 'equalTo' && value)
      return CustomValidators.equalTo(value)


    if (validationName === 'notEqualTo' && value)
      return CustomValidators.notEqualTo(value)


    if (validationName === 'arrayLength' && value)
      return CustomValidators.arrayLength(value)


    if (validationName === 'greaterThan' && value)
      return CustomValidators.gt(value)


    if (validationName === 'lessThan' && value)
      return CustomValidators.lt(value)


    if (validationName === 'range' && value && secondaryValue)
      return CustomValidators.range([value, secondaryValue])


    if (validationName === 'rangeLength' && value && secondaryValue)
      return CustomValidators.rangeLength([value, secondaryValue])

  }

  private _findErrorMessage(validationName, fieldKey, controlId, state?) {
    let _filteredValidationItem;
    if (state) {
      _filteredValidationItem = this.allValidations.filter(o => o.fieldKey === fieldKey && o.controlId === controlId && o.validation === validationName && o.state === state)
    }
    else {
      _filteredValidationItem = this.allValidations.filter(o => o.fieldKey === fieldKey && o.controlId === controlId && o.validation === validationName)
    }

    if (_filteredValidationItem.length > 0) {
      if (_filteredValidationItem[0].errorMessage) {
        //let validationLevel = (_filteredValidationItem[0].validationLevel == 'save' ? 'all' : _filteredValidationItem[0].validationLevel) || 'all'
        //let output = { errorMessage: _filteredValidationItem[0].errorMessage, validationLevel: validationLevel }
        let output = { errorMessage: _filteredValidationItem[0].errorMessage, validationEvent: _filteredValidationItem[0].validationEvent }
        return output
      }
      else {
        return null
      }
    }
  }

  private _findErrorMessage_old(validationName, fieldKey, controlId, state?) {
    let _filteredValidationItem;
    if (state) {
      _filteredValidationItem = this.allValidations.filter(o => o.fieldKey === fieldKey && o.controlId === controlId && o.validation === validationName && o.state === state)
    }
    else {
      _filteredValidationItem = this.allValidations.filter(o => o.fieldKey === fieldKey && o.controlId === controlId && o.validation === validationName)
    }

    if (_filteredValidationItem.length > 0) {
      if (_filteredValidationItem[0].errorMessage) {
        return _filteredValidationItem[0].errorMessage
      }
      else {
        return null
      }
    }
  }

  _getErrorMessageList(error, fieldKey, controlId, state?) {

    const validationList = this.validationList
    let listOfMessages = []
    error = error || {}

    validationList.forEach(validationName => {
      if (error[validationName]) {
        let messageAndLevel = this._findErrorMessage(validationName, fieldKey, controlId, state)
        listOfMessages.push(messageAndLevel)
      }
    })

    return listOfMessages;

  }

  _getErrorMessageList_old(error, fieldKey, controlId, state?) {

    let listOfMessages = []
    error = error || {}

    /**
     * Native 
     * Validations
     * List
     */

    if (error.required) {
      let message = this._findErrorMessage("required", fieldKey, controlId, state)
      listOfMessages.push(message)
    }

    if (error.requiredTrue) {
      let message = this._findErrorMessage("requiredTrue", fieldKey, controlId, state)
      listOfMessages.push(message)
    }

    if (error.email) {
      let message = this._findErrorMessage("email", fieldKey, controlId, state)
      listOfMessages.push(message)
    }

    if (error.min) {
      let message = this._findErrorMessage("min", fieldKey, controlId, state)
      listOfMessages.push(message)
    }

    if (error.max) {
      let message = this._findErrorMessage("max", fieldKey, controlId, state)
      listOfMessages.push(message)
    }

    if (error.minlength) {
      let message = this._findErrorMessage("minlength", fieldKey, controlId, state)
      listOfMessages.push(message)
    }

    if (error.maxlength) {
      let message = this._findErrorMessage("maxlength", fieldKey, controlId, state)
      listOfMessages.push(message)
    }

    if (error.pattern) {
      let message = this._findErrorMessage("pattern", fieldKey, controlId, state)
      listOfMessages.push(message)
    }


    /**
      * Custom 
      * Validation
      * List
      */

    if (error.digits) {
      let message = this._findErrorMessage("digits", fieldKey, controlId, state)
      listOfMessages.push(message)
    }

    if (error.number) {
      let message = this._findErrorMessage("number", fieldKey, controlId, state)
      listOfMessages.push(message)
    }

    if (error.url) {
      let message = this._findErrorMessage("url", fieldKey, controlId, state)
      listOfMessages.push(message)
    }

    if (error.date) {
      let message = this._findErrorMessage("date", fieldKey, controlId, state)
      listOfMessages.push(message)
    }

    if (error.dateISO) {
      let message = this._findErrorMessage("dateISO", fieldKey, controlId, state)
      listOfMessages.push(message)
    }

    if (error.creditCard) {
      let message = this._findErrorMessage("creditCard", fieldKey, controlId, state)
      listOfMessages.push(message)
    }

    if (error.json) {
      let message = this._findErrorMessage("json", fieldKey, controlId, state)
      listOfMessages.push(message)
    }

    if (error.base64) {
      let message = this._findErrorMessage("base64", fieldKey, controlId, state)
      listOfMessages.push(message)
    }

    if (error.minDate) {
      let message = this._findErrorMessage("minDate", fieldKey, controlId, state)
      listOfMessages.push(message)
    }

    if (error.maxDate) {
      let message = this._findErrorMessage("maxDate", fieldKey, controlId, state)
      listOfMessages.push(message)
    }

    if (error.uuid) {
      let message = this._findErrorMessage("uuid", fieldKey, controlId, state)
      listOfMessages.push(message)
    }

    if (error.equal) {
      let message = this._findErrorMessage("equal", fieldKey, controlId, state)
      listOfMessages.push(message)
    }

    if (error.notEqual) {
      let message = this._findErrorMessage("notEqual", fieldKey, controlId, state)
      listOfMessages.push(message)
    }
    if (error.equalTo) {
      let message = this._findErrorMessage("equalTo", fieldKey, controlId, state)
      listOfMessages.push(message)
    }

    if (error.notEqualTo) {
      let message = this._findErrorMessage("notEqualTo", fieldKey, controlId, state)
      listOfMessages.push(message)
    }

    if (error.arrayLength) {
      let message = this._findErrorMessage("arrayLength", fieldKey, controlId, state)
      listOfMessages.push(message)
    }

    if (error.greaterThan) {
      let message = this._findErrorMessage("greaterThan", fieldKey, controlId, state)
      listOfMessages.push(message)
    }

    if (error.lessThan) {
      let message = this._findErrorMessage("lessThan", fieldKey, controlId, state)
      listOfMessages.push(message)
    }

    if (error.range) {
      let message = this._findErrorMessage("range", fieldKey, controlId, state)
      listOfMessages.push(message)
    }

    if (error.rangeLength) {
      let message = this._findErrorMessage("rangeLength", fieldKey, controlId, state)
      listOfMessages.push(message)
    }



    return listOfMessages;

  }

  public check_isRequired(payload, fieldValidation) {
    if (fieldValidation.validationRule.type == 'required' && !payload[fieldValidation.fieldKey]) {
      return true;
    } else
      return false
  }

  public check_pattern(fieldValue) {
    // let pattern = new RegExp(/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/g)
    let pattern = new RegExp(/^[a-zA-Z0-9- ]*$/)
    return pattern.test(fieldValue);
  }

  public check_maxLength(payload, fieldValidation) {
    if (payload[fieldValidation.fieldKey] && payload[fieldValidation.fieldKey].length > fieldValidation.validationRule.valueForParameter)
      return true
    else
      return false;
  }



}
